import {
  ENTER_NEW_PASSWORD,
  ENTER_OTP,
  ENTER_USERNAME,
} from '~/utils/enums/auth/components/forms/ForgotPasswordSteps';

const EnterUsername = {
  title: 'Forgot Password',
  subtitle: `Enter your email and we’ll send you a password reset link`,
  dataTestId: 'enter-username',
  fields: {
    email: {
      label: 'Email',
      placeholder: 'Email',
      dataTestId: 'email',
    },
  },
  actions: {
    submitButton: {
      label: 'Continue',
      dataTestId: 'continue-button',
    },
  },
};

const EnterOtp = {
  title: 'Verification Code',
  subtitle: `Enter the code sent to <EMAIL>`,
  dataTestId: 'enter-otp',
  fields: {
    otp: {
      label: 'OTP',
      length: 5,
      dataTestId: 'otp',
    },
  },
  actions: {
    submitButton: {
      label: 'Continue',
      dataTestId: 'continue-button',
    },
  },
};

const EnterNewPassword = {
  title: 'New Password',
  subtitle: `Enter your new password to log into <EMAIL>`,
  dataTestId: 'enter-new-password',
  fields: {
    password: {
      label: 'New Password',
      placeholder: 'New password',
      dataTestId: 'new-password',
    },
    password_confirmation: {
      label: 'Confirm Password',
      placeholder: 'Confirm password',
      dataTestId: 'confirm-password',
    },
  },
  actions: {
    submitButton: {
      label: 'Confirm New Password',
      dataTestId: 'continue-button',
    },
  },
};

const ForgotPasswordForm = {
  steps: [
    { key: ENTER_USERNAME, data: EnterUsername },
    { key: ENTER_OTP, data: EnterOtp },
    { key: ENTER_NEW_PASSWORD, data: EnterNewPassword },
  ],

  messages: {
    success: 'Your password has been successfully reset!',
  },
};

export { EnterNewPassword, EnterOtp, EnterUsername, ForgotPasswordForm };
